import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

const POINTS = [
  "Comprehensive range of high-quality replacement parts",
  "Trusted partner for cafés, restaurants and large-scale kitchens",
  "Focused on minimising downtime and keeping operations smooth",
  "Fast, reliable and affordable solutions",
];

const About = () => (
  <div className="min-h-screen flex flex-col bg-white"><Navbar />
    <section className="bg-graphite text-white py-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="mono text-xs uppercase tracking-[0.2em] text-orange mb-3">About Us</div>
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight">Your trusted partner for restaurant equipment parts.</h1>
      </div>
    </section>
    <section className="max-w-4xl mx-auto px-4 sm:px-6 py-14">
      <p className="text-lg text-steel leading-relaxed">
        Welcome to <strong className="text-graphite">GOT PARTS</strong>. We are your trusted partner for all restaurant equipment parts,
        offering a comprehensive range of high-quality replacement parts designed to keep your kitchen equipment running at its best.
      </p>
      <p className="text-lg text-steel leading-relaxed mt-5">
        Whether you're a small café or a large-scale restaurant, we understand the importance of minimising downtime and maintaining
        smooth operations. We are committed to providing fast, reliable and affordable solutions to your commercial kitchen needs —
        now reimagined as a modern, technician-first platform where you can find and order any part in seconds.
      </p>
      <div className="grid sm:grid-cols-2 gap-3 mt-8">
        {POINTS.map((p) => (
          <div key={p} className="flex items-start gap-2.5"><CheckCircle2 className="w-5 h-5 text-orange shrink-0 mt-0.5" /><span className="text-steel">{p}</span></div>
        ))}
      </div>
      <div className="grid grid-cols-3 gap-4 mt-12">
        {[["15,000+", "Happy customers"], ["1,000s", "Parts catalogued"], ["Fast", "Fulfilment"]].map(([n, l]) => (
          <div key={l} className="border border-border rounded-lg p-5 text-center"><div className="text-2xl font-extrabold text-graphite">{n}</div><div className="text-xs text-steel-light uppercase tracking-wider mt-1">{l}</div></div>
        ))}
      </div>
      <Link to="/services" className="inline-flex items-center gap-2 mt-10 text-orange font-medium hover:underline">See what we offer <ArrowRight className="w-4 h-4" /></Link>
    </section>
    <Footer />
  </div>
);

export default About;
